import React, { useEffect, useContext } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserHistory } from "../store/slices/userHistorySlice";
import {
  fetchDiamondRewards,
  fetchGoldenReward,
  fetchSpinHistory,
} from "../store/slices/rewardsSlice";
import classes from "./UserhistoryPage.module.css";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";

import sadImg from "../assets/sad.png";
import happyImg from "../assets/happy.png";
import { FloatingChit } from "../components/FloatingChit";
import v2 from "../assets/v1.mp4"
import { HISTORY, COMMON, pageT } from "../utils/i18n";

const UserhistoryPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, HISTORY);
  const c = pageT(lang, COMMON);

  const historyData = useSelector((state) => state.userHistory.history);
  const historyStatus = useSelector((state) => state.userHistory.status);

  const spinData = useSelector((state) => state.rewards.spinHistory);
  const spinStatus = useSelector((state) => state.rewards.spinStatus);

  const goldenReward = useSelector((state) => state.rewards.goldenReward);
  const goldenStatus = useSelector((state) => state.rewards.goldenStatus);

  const diamondData = useSelector((state) => state.rewards.diamondRewards);
  const diamondStatus = useSelector((state) => state.rewards.diamondStatus);

  const loading =
    historyStatus === "loading" ||
    spinStatus === "loading" ||
    goldenStatus === "loading" ||
    diamondStatus === "loading";

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/");
      return;
    }

    dispatch(fetchUserHistory(token));
    dispatch(fetchSpinHistory(token));
    dispatch(fetchGoldenReward(token));
    dispatch(fetchDiamondRewards(token));
  }, [dispatch, navigate]);


  const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};


  const maxLevel =
    historyData.length > 0
      ? Math.max(...historyData.map((item) => item.level_no))
      : 0;

  return (
    <div className={classes.page}>

   
      <div className={classes.header}>
        <span
          className={classes.backArrow}
          onClick={() => navigate("/account")}
        >
          ←
        </span>
        <h2 className={classes.title}>📊 {t.levelHistory}</h2>
      </div>
          <div className={classes.floatingBg}>
        <FloatingChit color="yellow" delay={0} duration={8} x={10} y={80} rotate={360} icon="🎯" />
        <FloatingChit color="pink" delay={1} duration={7} x={20} y={90} rotate={-360} icon="📈" />
        <FloatingChit color="blue" delay={2} duration={9} x={80} y={85} rotate={360} icon="📉" />
        <FloatingChit color="green" delay={3} duration={10} x={60} y={95} rotate={360} icon="📩" />
        <FloatingChit color="red" delay={4} duration={9} x={30} y={35} rotate={360} icon="📊" />
        <FloatingChit color="transprent" delay={5} duration={10} x={40} y={50} rotate={360} icon="✈️" />
        <FloatingChit color="white" delay={6} duration={7} x={20} y={35} rotate={360} icon="🎭" />
        <FloatingChit color="blue" delay={7} duration={9} x={80} y={85} rotate={360} icon="🎲" />

      </div>
      


      {loading ? (
        <p className={classes.msg}>{c.loading}</p>
      ) : historyData.length === 0 ? (
        <p className={classes.msg}>{t.noHistory}</p>
      ) : (
        <>
        <div className={classes.tableWrapper}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th>{t.level}</th>
                <th>{t.points}</th>
                <th>{t.date}</th>
                <th>{t.riddle}</th>
                <th>{t.answer}</th>
              </tr>
            </thead>

            <tbody>
              {historyData.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span className={classes.levelBadge}>
                       {item.level_no}
                    </span>
                  </td>
                  <td className={classes.points}>
                    ⭐ {item.points_earned}
                  </td>
                  <td>
                    <span className={classes.date}>
                      {formatDate(item.earned_date)}
                    </span>
                  </td>
                  <td className={classes.question}>
                    {item.riddle_question}
                  </td>
                  <td className={classes.ans}>
                    {item.riddle_ans}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
</div>
  <h2 className={classes.title}>🌟 {t.spinHistory}</h2>
  <div className={classes.tableWrapper}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th>{t.spin}</th>
                <th>{t.points}</th>
                <th>{t.date}</th>
              </tr>
            </thead>

            <tbody>
              {spinData.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span className={classes.levelBadge}>
                      spin {item.level_no}
                    </span>
                  </td>
                  <td className={classes.points}>
                    ⭐ {item.reward_points}
                  </td>
                  <td>
                    <span className={classes.date}>
                      {formatDate(item.spin_date)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
</div>
          <h2 className={classes.title}>🌟 {t.goldenTitle}</h2>
           <div className={classes.tableWrapper}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th>{t.goldenReward}</th>
                <th>{t.reward}</th>
                <th>{t.date}</th>
              </tr>
            </thead>
            <tbody>
                <tr>
                  <td>
                    <span className={classes.levelBadge}>
                      {t.goldenRewardLabel}
                    </span>
                  </td>
                  <td className={classes.points}>
                    ⭐ {goldenReward?.reward}
                  </td>
                  <td>
                    <span className={classes.date}>
                      {formatDate(goldenReward?.win_reward_date)}
                    </span>
                  </td>
                </tr>
             
            </tbody>
          </table>
</div>

<h2 className={classes.title}>💎 {t.diamondTitle}</h2>
 <div className={classes.tableWrapper}>
<table className={classes.table}>
  <thead>
    <tr>
      <th>{t.reward}</th>
      <th>{t.type}</th>
      <th>{t.date}</th>
    </tr>
  </thead>

  <tbody>
    {diamondData.length > 0 ? (
      diamondData.map((item, index) => (
        <tr key={index}>
          <td>
            <span className={classes.levelBadge}>
              {item.reward_name || item.reward}
            </span>
          </td>
          <td className={classes.points}>
            {item.reward_type || t.diamond}
          </td>
          <td>
            <span className={classes.date}>
              {formatDate(item.claimed_at || item.win_reward_date)}
            </span>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={3} style={{ textAlign: "center" }}>
          {t.noDiamond}
        </td>
      </tr>
    )}
  </tbody>
</table>
</div>


         <div className={classes.imageBox}>
  <video
    autoPlay
    loop
    muted
    playsInline
    className={classes.resultVideo}
  >
    <source src={v2} type="video/webm" />
  </video>
</div>

        </>
      )}
    </div>
  );
};

export default UserhistoryPage;
